<template>
    <div>
      <national-patent-responsible-form :getNationalPatentResponsibleList="getNationalPatentResponsibleList" ref="nationalPatentResponsibleFormModal"></national-patent-responsible-form>
      <b-row>
        <b-col class="col-12">
          <div style="float:right;" class="custom-search d-flex justify-content-end">
            <b-form-group>
              <div class="d-flex align-items-center">
                <b-button style="float:right;" size="sm" variant="outline-primary"
                  @click="getInfo()">{{ $t('nationalPatentResponsible.add') }}</b-button>
              </div>
            </b-form-group>
          </div>
        </b-col>
      </b-row>
      <!-- table -->
      <vue-good-table 
      id="nationalPatentResponsibleTable"
      ref="nationalPatentResponsibleTable" 
      :columns="columns" 
      :rows="rows"
      styleClass="vgt-table condensed tableSize"
      :select-options="{
        enabled: false,
        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
        selectionInfoClass: 'custom-class',
        selectionText: 'rows selected',
        clearSelectionText: 'clear',
        disableSelectInfo: true, // disable the select info panel on top
        selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
      }" 
        theme="my-theme">
        <div slot="emptystate">
          {{ $t('dataTable.data_not_found') }}
        </div>
        <!-- Row: Table Row -->
        <template slot="table-column" slot-scope="props">
          <span v-if="props.column.field === 'responsibleName'" class="text-nowrap">
            {{ $t('nationalPatentResponsible.name') }}
          </span>
          <span v-else-if="props.column.field === 'email'" class="text-nowrap">
            {{ $t('nationalPatentResponsible.email') }}
          </span>
          <span v-else-if="props.column.field === 'mailContactType'" class="text-nowrap">
            {{ $t('nationalPatentResponsible.mail_contact_type') }}
          </span>
          <span v-else-if="props.column.field === 'responsibleField'" class="text-nowrap">
            {{ $t('nationalPatentResponsible.field') }}
          </span>
          <span v-else-if="props.column.field === 'process'" class="text-nowrap">
            {{ $t('others.process') }}
          </span>
        </template>
        <!-- Column: Table Column -->
        <template slot="table-row" slot-scope="props">
          <!-- Column: Process -->
          <span v-if="props.column.field === 'process'">
            <span>
              <b-button v-b-tooltip.html :title="$t('others.delete')" variant="warning" class="btn-icon mb-1 ml-1"
                size="sm" @click="deleted(props.row)">
                <feather-icon icon="XIcon" />
              </b-button>
            </span>
          </span>
        </template>
      </vue-good-table>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      nationalPatentId: Number,
      clientId:Number
    },
    data() {
      return {
        dir: false,
        columns: [
          {
            label: this.$t('nationalPatentResponsible.name') ,
            field: `responsibleName`,
          },
          {
            label: this.$t('nationalPatentResponsible.email'),
            field: `email`,
          },
          {
            label: this.$t('nationalPatentResponsible.mail_contact_type'),
            field: `mailContactType`,
          },
          {
            label: this.$t('nationalPatentResponsible.field'),
            field: `responsibleField`,
          },
          {
            label: 'Process',
            field: 'process',
            width: '10em'
          },
        ],
        rows: [],
        searchTerm: '',
      }
    },
    mounted() {
      this.getNationalPatentResponsibleList()
    },
    methods: {
      async deleted(data) {
        data = { id: data.id }
        const controller = { name: 'NationalPatentResponsible' }
        const payload = { data: data, controller: controller }
        this.$DeleteConfirm().then(result => {          
          if (result.value) {
            this.$store.dispatch('moduleAuth/delete', payload).then((response) => {
              if (response.data.resultStatus == true) {
                this.$DeleteAlert()
                this.getNationalPatentResponsibleList()
              } else {
                this.$WarningAlert(response.data.resultMessage)
                this.getNationalPatentResponsibleList()
              }
            })
          }
        })
      },
      async getInfo() {
        this.$refs.nationalPatentResponsibleFormModal.showInfo(this.nationalPatentId, this.clientId)
      },
      getNationalPatentResponsibleList() {
        this.rows = [] 
        const data = { id: this.nationalPatentId }
        const controller = { name: 'NationalPatentResponsible', actionName:'GetNationalPatentResponsibleListByNationalPatentId' }
        const payload = { data: data, controller: controller }
        this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
          if (response.data.resultStatus == true) {  
            response.data.nationalPatentResponsibleList.forEach(element => {
              this.rows.push(element)
            })
          }
          else {
            this.$WarningAlert(response.data.resultMessage)
          }
        }
        )
      }
    },
  }
  </script>
  <style lang="scss" >
    .tableSize {
      font-size: 13px!important;
      border-collapse: collapse;
      width: 100%;
      max-width: 100%;
      table-layout: auto;
  }
  </style>
  